import React from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";

interface SectionCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  description,
  children,
}) => (
  <Card sx={{ border: "1px solid", borderColor: "divider", boxShadow: "none" }}>
    <CardContent>
      <Stack spacing={2}>
        <Box>
          <Typography variant="subtitle1" fontWeight={600}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Box>
        {children}
      </Stack>
    </CardContent>
  </Card>
);
